let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLrPX")).then(() => parcelRequire('kI9fY'));